export const GET_PICK_AND_DROP_SETTINGS = "GET_PICK_AND_DROP_SETTINGS";
